var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { Button } from '../Button';
import { buttonBGColors, getVariant } from '../Button/Button.styles';
import { Card } from '../Card';
import { Spinner } from '../Spinner';
export var StyledDropdownMenu = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  max-height: 40vh;\n  max-width: 248px;\n"], ["\n  display: flex;\n  max-height: 40vh;\n  max-width: 248px;\n"])));
export var StyledDropdownSpinner = styled(Spinner)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 6px; // TODO one-off\n"], ["\n  margin: 0 6px; // TODO one-off\n"])));
export var StyledDropdownButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  pointer-events: ", ";\n\n  ", "\n"], ["\n  pointer-events: ", ";\n\n  ", "\n"])), function (_a) {
    var disabled = _a.disabled, $loading = _a.$loading;
    return disabled || $loading ? 'none' : 'inherit';
}, function (_a) {
    var $loading = _a.$loading, variant = _a.variant;
    if ($loading) {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        background: ", ";\n      "], ["\n        background: ", ";\n      "])), buttonBGColors[getVariant(variant)].hover);
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Dropdown.styles.js.map